import { DEFAULT_CRM_TOKEN } from './constants';
export const crmToken = process.env.CRM_TOKEN || DEFAULT_CRM_TOKEN;
export function getPrivateSubmissionAppOrigin() {
    const origin = process.env.PRIVATE_SUBMISSION_URL;
    if (!origin) {
        return '';
    }
    try {
        return new URL(origin).origin;
    }
    catch {
        return '';
    }
}
export function privateSubmissionUrl(path) {
    const origin = getPrivateSubmissionAppOrigin().replace(/\/$/, '');
    if (!origin) {
        return '';
    }
    return `${origin}/private-submission/${path}?crm_token=${crmToken}`;
}
